<template>
  <div class="form-group" :class="{ 'has-error': errors.has(validationKey) }">
    <label for="email-header"><span v-if="isRequired">*</span> {{ label }}</label>
    <textarea class="form-control"
              ref="textarea"
              :id="name"
              :value="value"
              :placeholder="label"
              :name="name"
              v-validate="validators"
              :data-vv-as="label"
              v-on:input="$emit('input', $event.target.value)"
              v-bind="$attrs"
    />
    <span v-show="errors.has(validationKey)" class="help-block ">{{ errors.first(validationKey) }}</span>
    <span class="small">*Available shortcodes (click to insert at cursor):
      <span v-for="(code, idx) in shortcodes" @click="insertShortcode(code)">
        <strong class="cursor-pointer">%{{code}}%</strong><template v-if="idx !== shortcodes.length-1">, </template>
      </span>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    validationScope: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false,
    },
    shortcodes: {
      type: Array,
      required: true,
    },
    validators: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    isRequired() {
      if (this.validators) {
        if (typeof this.validators === 'string') {
          return this.validators.includes('required');
        } else if (this.validators.required) {
          return true;
        }
      }
    },
    validationKey() {
      if (this.validationScope) {
        return `${this.validationScope}.${this.name}`;
      } else {
        return this.name;
      }
    },
  },
  methods: {
    insertShortcode (code) {
      const position = this.$refs.textarea.selectionStart;
      const value = this.value.substring(0, position) + '%'+code+'%' + this.value.substring(position);
      this.$emit('input', value);
    },
  },
  inject: {
    $validator: '$validator'
  },
}
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ShortcodesEditor.vue?16f54acc